var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loginBox"}},[_vm._m(0),_c('div',[_c('idcards')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',[_c('img',{attrs:{"src":require("../../assets/img/logo.png"),"alt":"同济老年大学"}})])
}]

export { render, staticRenderFns }